export default [
  { value: 'approved', label: 'Aprobado' },
  { value: 'in_process', label: 'En Proceso' },
  { value: 'not_started', label: 'No Comenzado' },
  { value: 'rejected', label: 'Reprobado' }
];
